import { ClearOutlined } from "@ant-design/icons";

export default function ArchivedAttachment() {
    return (
        <div className="zero-blue" style={{
            width: "100px",
            height: "100px",
            borderRadius: "2px",
            backgroundColor: "#f6f6f6",
            border: "1px solid #e5e5e5",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
        }}>
            <ClearOutlined style={{ fontSize: "2.4rem" }} />
            <span style={{ fontSize: "1.2rem" }}>Archived Content</span>
        </div>
    );
}
